module.exports = __webpack_public_path__ + "static/media/Help.ffe0fd6b.png";